module.exports = __webpack_public_path__ + "static/media/2.ae152e22.png";